import { render } from "./register.vue?vue&type=template&id=5bf62b68&scoped=true"
import script from "./register.js?vue&type=script&lang=js&external"
export * from "./register.js?vue&type=script&lang=js&external"

import "./register.css?vue&type=style&index=0&id=5bf62b68&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf62b68"]])

export default __exports__